// components/ManageOptions/DropdownCard.js
import React from "react";
import {
  Card,
  CardContent,
  Tabs,
  Tab,
  Typography,
  Box,
  Fab,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DropdownTabContent from "./DropdownTabContent";

const DropdownCard = ({
  fieldTypes,
  tabIndex,
  setTabIndex,
  currentField,
  loading,
  error,
  options,
  onEdit,
  onDelete,
  onAddClick,
  username,
  role,
}) => {
  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: "1200px",
        boxShadow: 3,
      }}
    >
      <Tabs
        value={tabIndex}
        onChange={(e, newIndex) => setTabIndex(newIndex)}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
      >
        {fieldTypes.map((type) => (
          <Tab key={type} label={type} />
        ))}
      </Tabs>

      <CardContent>
        <Typography variant="h6" mt={3}>
          {currentField}
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" mt={2}>
            {error}
          </Typography>
        ) : (
          <Box mt={1}>
            <DropdownTabContent
              options={options}
              onEdit={onEdit}
              onDelete={onDelete}
              username={username}
              role={role}
            />
          </Box>
        )}

        {/* Floating Add Button */}
        <Tooltip
          title={`Add new ${currentField} value`}
          arrow
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: "16px", // bigger text
                padding: "10px 14px", // bigger tooltip box
              },
            },
            arrow: {
              sx: {
                "&:before": {
                  fontSize: "16px", // bigger arrow
                },
              },
            },
          }}
        >
          <Fab
            color="primary"
            sx={{ position: "fixed", bottom: 85, right: 82 }}
            onClick={onAddClick}
            aria-label="Add New Option"
          >
            <AddIcon />
          </Fab>
        </Tooltip>
      </CardContent>
    </Card>
  );
};

export default DropdownCard;
